module.exports = __webpack_public_path__ + "img/logo_gray.13842014.svg";